var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage-Credit-Cards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00:-Table-of-Contents",
    transform: "translate(-724.000000, -628.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/edit",
    transform: "translate(724.624344, 628.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-5",
    fill: "#444B68",
    points: "9.84632445 2.83628712 13.1284326 6.11839527 4.92316223 14.3236656 1.64105408 11.0415575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6826116,1.41421356 L12.0810651,2.01576009 L13.9489596,3.88365467 L14.5505062,3.28210815 L12.6826116,1.41421356 Z",
    id: "Rectangle-Copy-6",
    stroke: "#444B68",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-8",
    fill: "#444B68",
    points: "0.820527038 11.8620845 4.10263519 15.1441927 3.01358938e-12 15.9647197"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.9a9b23df270239190587247ac0b981f9.svg";
export { ForwardRef as ReactComponent };